import React from 'react';
import { useT } from '@repo/common';
import { POLICY_LANGS, availableLangs } from './usePolicyVersions';
import { ReactComponent as ArrowIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-bottom.svg';

// 정책 문서 상단의 시행일(버전) 선택과 한국어·영어 전환
const LANG_LABELS = { ko: '한국어', en: 'English' };

const PolicyToolbar = ({
  versions,
  selected,
  current,
  lang,
  hasBilingual,
  onVersionChange,
  onLangChange,
}) => {
  const t = useT();
  const available = availableLangs(selected);
  const ordered = [...versions].reverse();

  const optionLabel = (version) => {
    const date = version.effectiveDate.replace(/-/g, '.');
    if (version === current) return `${date} ${t('(current)', '(현재 시행)')}`;
    if (current && version.effectiveDate > current.effectiveDate) {
      return `${date} ${t('(upcoming)', '(시행 예정)')}`;
    }
    return date;
  };

  return (
    <div className='flex w-full flex-wrap items-center justify-between gap-[12px]'>
      <label className='relative flex items-center'>
        <span className='sr-only'>{t('Effective date', '시행일')}</span>
        <select
          value={selected.effectiveDate}
          onChange={(e) => onVersionChange(e.target.value)}
          className='appearance-none cursor-pointer rounded-[10px] border border-grayscale-gray02 bg-grayscale-gray00 py-[8px] pl-[14px] pr-[38px] typo-b14Strong text-text-primary focus:outline-none focus:border-grayscale-gray04'
        >
          {ordered.map((version) => (
            <option key={version.effectiveDate} value={version.effectiveDate}>
              {optionLabel(version)}
            </option>
          ))}
        </select>
        <ArrowIcon className='pointer-events-none absolute right-[14px] text-icon-secondary' />
      </label>

      {available.length > 1 ? (
        <div role='tablist' className='flex rounded-[10px] bg-grayscale-gray01 p-[3px]'>
          {POLICY_LANGS.map((code) => (
            <button
              key={code}
              type='button'
              role='tab'
              aria-selected={lang === code}
              onClick={() => onLangChange(code)}
              className={`rounded-[8px] px-[14px] py-[6px] typo-b13Strong transition-colors ${
                lang === code
                  ? 'bg-grayscale-gray00 text-text-primary shadow-4'
                  : 'text-text-placeholder hover:text-text-secondary'
              }`}
            >
              {LANG_LABELS[code]}
            </button>
          ))}
        </div>
      ) : (
        hasBilingual && (
          <span className='typo-b13 text-text-placeholder'>
            {available[0] === 'ko'
              ? t('This version is available in Korean only.', '이 버전은 국문만 있어요.')
              : t('This version is available in English only.', '이 버전은 영문만 있어요.')}
          </span>
        )
      )}
    </div>
  );
};

export default PolicyToolbar;
